// Ported from hotwire-flow (MIT, @hotwirebits/flow) into conek-ui. The engine
// logic is upstream's; identifiers/events/classes follow the conek contract in
// docs/superpowers/specs/2026-09-09-flow-graph-components-design.md §2.
import { Controller } from "@hotwired/stimulus"

// Draggable sidebar node type for DnD onto canvas.
export default class extends Controller {
  static values = { type: { type: String, default: "default" }, label: { type: String, default: "" } }
  static outlets = ["ui--flow"]

  connect() {
    // Keyboard a11y: the palette markup carries role=button/tabindex=0/
    // aria-label; the Enter/Space behavior is attached here (node_controller
    // pattern — directly-mounted controllers get the listener too).
    this._keydownHandler = (e) => this.keyDown(e)
    this.element.addEventListener("keydown", this._keydownHandler)
  }

  disconnect() {
    if (this._keydownHandler) this.element.removeEventListener("keydown", this._keydownHandler)
  }

  dragStart(event) {
    event.dataTransfer.setData("application/hotwire-flow-node", JSON.stringify({
      type: this.typeValue, label: this.labelValue
    }))
    event.dataTransfer.effectAllowed = "copy"
    this.element.classList.add("dragging")
  }

  dragEnd() {
    this.element.classList.remove("dragging")
  }

  // Keyboard a11y: Enter/Space on a focused palette item adds the node
  // without a pointer drag. The payload matches the canvas drop path's
  // `{type, label, x, y}` (flow coords), positioned at the canvas viewport
  // center via the outlet's screenToFlow — `ui--flow:addnode` being the
  // context menu's add-here event, extended with the drop payload's
  // type/label. Without the outlet the event still fires at {x: 0, y: 0}.
  keyDown(event) {
    if (event.key !== "Enter" && event.key !== " ") return
    event.preventDefault()
    event.stopPropagation()

    // Accessing the outlet getter throws when the outlet attribute is
    // absent (Stimulus "missing outlet") — gate the read on the attribute.
    const flow = this.element.hasAttribute("data-ui--flow-dnd-node-ui--flow-outlet")
      ? this.uiFlowOutlet
      : null
    const rect = flow?.element?.getBoundingClientRect()
    const center = rect && rect.width > 0 && rect.height > 0
      ? flow.screenToFlow(rect.left + rect.width / 2, rect.top + rect.height / 2)
      : { x: 0, y: 0 }

    this.element.dispatchEvent(new CustomEvent("ui--flow:addnode", {
      detail: { type: this.typeValue, label: this.labelValue, x: center.x, y: center.y },
      bubbles: true
    }))
  }
}
